"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[259],{

/***/ 28842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BaseFunc; }
});

;// CONCATENATED MODULE: ./src/utils/bloomchicdata/sensors.ts
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var Sensors = /*#__PURE__*/ function() {
    "use strict";
    function Sensors(isLoign, isNew, param, param1) {
        var enableTrack = param === void 0 ? true : param, enableConsole = param1 === void 0 ? false : param1;
        _classCallCheck(this, Sensors);
        this.EnableTrack = enableTrack;
        this.EnableConsole = enableConsole;
        this.IsLogin = isLoign;
        this.IsNew = isNew;
        this._sensors = this.sensor_init();
    }
    _createClass(Sensors, [
        {
            key: "sensor_init",
            value: function sensor_init() {
                // window.sensors.init({
                //   server_url: 'https://unicorn.bloomchic.com/sa?project=default',
                //   show_log: false,
                //   heatmap: {
                //     clickmap: 'default',
                //     scroll_notice_map: 'default',
                //   },
                //   is_track_single_page: true,
                //   use_client_time: true,
                //   send_type: 'beacon',
                //   is_track_device_id: true,
                //   preset_properties: {
                //     latest_utm: true,
                //     latest_traffic_source_type: true,
                //     latest_search_keyword: true,
                //     latest_referrer: true,
                //     latest_referrer_host: true,
                //     latest_landing_page: true,
                //     url: true,
                //     title: true,
                //   },
                // })
                window.sensors.registerPage({
                    web_platform_type: window.innerWidth >= 768 ? 'PC_Web' : 'Mobile_Web' /* app Platform_type */ ,
                    web_language: navigator.language,
                    referrer_url: localStorage.getItem('sensor-referrer'),
                    web_is_login: this.IsLogin,
                    is_new: this.IsNew
                });
                window.sensors.quick('useModulePlugin', 'SiteLinker', {
                    linker: [
                        {
                            part_url: 'shop.bloomchic.com',
                            after_hash: false
                        },
                        {
                            part_url: 'bloomchic.com',
                            after_hash: false
                        },
                        {
                            part_url: 'dev-shop.bloomchic.com',
                            after_hash: false
                        }, 
                    ]
                });
                // if (typeof window !== 'undefined') window.sensors = sensors
                return window.sensors;
            }
        },
        {
            key: "track",
            value: function track(event, data) {
                if (this.EnableConsole) {
                    console.log(event, data);
                }
                if (this.EnableTrack) {
                    this._sensors.track(event, data);
                }
            }
        },
        {
            key: "autoTrack",
            value: function autoTrack() {
                this._sensors.quick('autoTrack');
            }
        },
        {
            key: "abtest",
            value: function abtest(testName, callback) {
                this._abtest.asyncFetchABTest({
                    param_name: testName,
                    value_type: 'String',
                    callback: function(result) {
                        callback(result);
                    }
                });
            }
        }
    ]);
    return Sensors;
}();
/* eslint-disable import/extensions */ /* eslint-disable prettier/prettier */ /* eslint-disable no-underscore-dangle */ /* eslint-disable class-methods-use-this */ /* eslint-disable import/prefer-default-export */ // import sensors from '../../assets/js/sensorsdata.es6.min.js'


;// CONCATENATED MODULE: ./src/utils/precision.ts
// 加
Number.prototype.add = function() {
    for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
        arg[_key] = arguments[_key];
    }
    var r1 = void 0;
    var r2 = void 0;
    var m = void 0;
    var result = Number(this);
    arg.forEach(function(value) {
        try {
            r1 = result.toString().split('.')[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = value.toString().split('.')[1].length;
        } catch (e1) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        result = Math.round(result * m + Number(value) * m) / m;
    });
    return result;
};
// 减
Number.prototype.sub = function() {
    for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
        arg[_key] = arguments[_key];
    }
    var r1 = void 0;
    var r2 = void 0;
    var m = void 0;
    var result = Number(this);
    arg.forEach(function(value) {
        try {
            r1 = result.toString().split('.')[1].length;
        } catch (e) {
            r1 = 0;
        }
        try {
            r2 = value.toString().split('.')[1].length;
        } catch (e2) {
            r2 = 0;
        }
        m = Math.pow(10, Math.max(r1, r2));
        var n = r1 >= r2 ? r1 : r2;
        result = Number((Math.round(result * m - value * m) / m).toFixed(n));
    });
    return result;
};
// 乘
Number.prototype.mul = function() {
    for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
        arg[_key] = arguments[_key];
    }
    var result = this;
    arg.forEach(function(value) {
        var m = 0;
        var s1 = result.toString();
        var s2 = value.toString();
        try {
            m += s1.split('.')[1].length;
        } catch (e) {
        }
        try {
            m += s2.split('.')[1].length;
        } catch (e3) {
        }
        result = Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
    });
    return result;
};
// 除
Number.prototype.div = function() {
    for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
        arg[_key] = arguments[_key];
    }
    var result = this;
    arg.forEach(function(value) {
        var t1 = 0;
        var t2 = 0;
        var r1;
        var r2;
        try {
            t1 = result.toString().split('.')[1].length;
        } catch (e) {
        }
        try {
            t2 = value.toString().split('.')[1].length;
        } catch (e4) {
        }
        r1 = Number(result.toString().replace('.', ''));
        r2 = Number(value.toString().replace('.', ''));
        result = r1 / r2 * Math.pow(10, t2 - t1);
    });
    return result;
};
/* eslint-disable prefer-const */ /* eslint-disable no-empty */ /* eslint-disable no-extend-native */ /* eslint-disable func-names */ /* eslint-disable no-restricted-properties */ 

// EXTERNAL MODULE: ./src/api/service/user.ts
var user = __webpack_require__(48901);
// EXTERNAL MODULE: ./src/utils/helpers.ts
var helpers = __webpack_require__(37336);
// EXTERNAL MODULE: ./src/utils/bloomchicdata/utils.ts
var utils = __webpack_require__(21122);
;// CONCATENATED MODULE: ./src/utils/bloomchicdata/basefunc.ts





function basefunc_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function basefunc_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function basefunc_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) basefunc_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) basefunc_defineProperties(Constructor, staticProps);
    return Constructor;
}
var BaseFunc = /*#__PURE__*/ function() {
    "use strict";
    function BaseFunc() {
        basefunc_classCallCheck(this, BaseFunc);
        this.landingTime = new Date();
        this.scrollTimer = null;
        BaseFunc.sensors = null;
    }
    basefunc_createClass(BaseFunc, [
        {
            key: "getVisitedProductCount",
            value: // eslint-disable-next-line class-methods-use-this
            function getVisitedProductCount() {
                return BaseFunc.visited_product.length;
            }
        },
        {
            key: "resetVisitedProduct",
            value: // eslint-disable-next-line class-methods-use-this
            function resetVisitedProduct() {
                BaseFunc.visited_product = [];
            }
        },
        {
            key: "getSensors",
            value: function getSensors() {
                if (this != null) {
                    if (BaseFunc.sensors != null) {
                        BaseFunc.sensors.IsLogin = BaseFunc.isLogin();
                        BaseFunc.sensors.IsNew = BaseFunc.isNew();
                    } else {
                        BaseFunc.sensors = new Sensors(BaseFunc.isLogin(), BaseFunc.isNew(), true, false);
                    }
                }
                var _sensors;
                return (_sensors = BaseFunc.sensors) !== null && _sensors !== void 0 ? _sensors : new Sensors(true, true, true, true);
            }
        },
        {
            key: "getStayTime",
            value: function getStayTime() {
                var now = new Date();
                return Number(now.getTime().sub(this.landingTime.getTime()).div(1000).toFixed(2));
            }
        },
        {
            key: "getPageCode2",
            value: // eslint-disable-next-line class-methods-use-this
            function getPageCode2() {
                return BaseFunc.getPageCode();
            }
        },
        {
            key: "getPageID2",
            value: // eslint-disable-next-line class-methods-use-this
            function getPageID2() {
                return BaseFunc.getPageID();
            }
        },
        {
            key: "getAdminID2",
            value: // eslint-disable-next-line class-methods-use-this
            function getAdminID2(id) {
                return window.atob(id).replace(/\D/g, '');
            }
        },
        {
            key: "scrollEndShowing",
            value: function scrollEndShowing(elementArray, time, func) {
                var _this = this;
                document.addEventListener('scroll', function() {
                    if (_this.scrollTimer != null) {
                        clearTimeout(_this.scrollTimer);
                    }
                    // eslint-disable-next-line no-param-reassign
                    _this.scrollTimer = setTimeout(function() {
                        var currentShowing = BaseFunc.getCurrentShowing(elementArray);
                        func(currentShowing);
                    }, time);
                });
            }
        }
    ], [
        {
            key: "isLogin",
            value: function isLogin() {
                var token = (0,user/* getToken */.LP)();
                return token != null;
            }
        },
        {
            key: "isNew",
            value: function isNew() {
                return !(0,helpers/* getStorage */.cF)('has_order');
            }
        },
        {
            key: "getHeader",
            value: function getHeader() {
                return document.getElementsByTagName('header')[0];
            }
        },
        {
            key: "getMain",
            value: function getMain() {
                return document.getElementsByTagName('main')[0];
            }
        },
        {
            key: "getFooter",
            value: function getFooter() {
                return document.getElementsByTagName('footer')[0];
            }
        },
        {
            key: "getPageCode",
            value: function getPageCode1() {
                return (0,utils/* getPageCode */.F)();
            }
        },
        {
            key: "getAdminID",
            value: function getAdminID(id) {
                return window.atob(id).replace(/\D/g, '');
            }
        },
        {
            key: "getPageID",
            value: function getPageID() {
                var pageID = '';
                switch(this.getPageCode()){
                    case '首页':
                        pageID = '首页';
                        break;
                    case '商品列表':
                        var ref;
                        var _id;
                        pageID = this.getAdminID((_id = (ref = document.getElementById('collection')) === null || ref === void 0 ? void 0 : ref.dataset.id) !== null && _id !== void 0 ? _id : '');
                        break;
                    case '商品详情页':
                        var ref1;
                        pageID = (ref1 = document.getElementById('product')) === null || ref1 === void 0 ? void 0 : ref1.dataset.spu;
                        break;
                    default:
                        break;
                }
                return pageID;
            }
        },
        {
            key: "getSpuFromSku",
            value: function getSpuFromSku(sku) {
                var reg = /.{11,14}\d(?=\D)/g;
                var result = reg.exec(sku);
                var spu = result == null ? '' : result[0];
                return spu;
            }
        },
        {
            key: "getHeaderHeight",
            value: function getHeaderHeight() {
                var result = 0;
                var active = this.getHeader().getElementsByClassName('active');
                if (active.length > 0) {
                    result = active[0].clientHeight;
                } else {
                    result = this.getHeader().clientHeight;
                }
                return result;
            }
        },
        {
            key: "getCurrentShowing",
            value: function getCurrentShowing(elementArray) {
                var result = new Array();
                var headerHeight = this.getHeaderHeight();
                var containerHeigh = Number(window.innerHeight).sub(headerHeight);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
                for(var i = 0; i < elementArray.length; i += 1){
                    var section = elementArray[i];
                    var sectionClient = section.getBoundingClientRect();
                    var isV = false;
                    // console.log('huey-containerHeigh', containerHeigh)
                    if (section.clientHeight <= containerHeigh) {
                        if (/* 上边缘在视区范围内 */ // section.offsetTop >= scrollTop.add(headerHeight) && // 上边缘离开临界
                        sectionClient.top >= 0 && sectionClient.top <= containerHeigh && /* 下边缘在视区范围内 */ // section.offsetTop.add(section.offsetHeight) <= scrollTop.add(window.innerHeight) // 下边缘露出临界
                        sectionClient.top.add(section.clientHeight) >= 0 && sectionClient.top.add(section.clientHeight) <= containerHeigh) {
                            isV = true;
                        }
                    /* 上边缘露出 */ } else if (// section.offsetTop <= scrollTop.add(window.innerHeight).sub(100) && // 上边缘露出临界-露出100像素
                    sectionClient.top.add(100) < containerHeigh && // section.offsetTop.add(section.offsetHeight) >= scrollTop.add(headerHeight).add(100)
                    sectionClient.top.add(section.clientHeight).sub(100) > 0) {
                        isV = true;
                    }
                    if (isV) {
                        var isH = false;
                        if (section.offsetWidth <= window.innerWidth) {
                            /* 判断水平是否露出 */ isH = sectionClient.left >= 0 && sectionClient.right <= window.innerWidth;
                        } else {
                            /* 判断是否有部分显示于页面 */ isH = sectionClient.left - window.innerWidth < 0 && sectionClient.right > 0;
                        }
                        if (isH) {
                            result.push(section);
                        }
                    }
                }
                return result;
            }
        },
        {
            key: "createLocalView",
            value: function createLocalView(name) {
                var saveLocalList = {
                    time: new Date().getTime(),
                    datas: []
                };
                localStorage.setItem(name, JSON.stringify(saveLocalList));
                return saveLocalList;
            }
        },
        {
            key: "getLocalView",
            value: function getLocalView(name) {
                var localViewStr = localStorage.getItem(name);
                var localView = localViewStr == null ? this.createLocalView(name) : JSON.parse(localViewStr);
                if (localView.time + 2 * 1000 * 60 * 60 < new Date().getTime() || localView.datas.length >= 10000) {
                    localView = this.createLocalView(name);
                }
                return localView;
            }
        },
        {
            key: "saveLocalView",
            value: function saveLocalView(name, id) {
                var canSave = false;
                var localView = this.getLocalView(name);
                if (!localView.datas.includes(id)) {
                    canSave = true;
                    localView.datas.push(id);
                    localStorage.setItem(name, JSON.stringify(localView));
                }
                return canSave;
            }
        }
    ]);
    return BaseFunc;
}();
BaseFunc.visited_product = [];



/***/ }),

/***/ 31259:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CollectionPageSensor": function() { return /* binding */ CollectionPageSensor; }
/* harmony export */ });
/* harmony import */ var _basefunc__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28842);

function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var CollectionPageSensor = /*#__PURE__*/ function(BaseFunc) {
    "use strict";
    _inherits(CollectionPageSensor, BaseFunc);
    var _super = _createSuper(CollectionPageSensor);
    function CollectionPageSensor() {
        _classCallCheck(this, CollectionPageSensor);
        return _super.apply(this, arguments);
    }
    _createClass(CollectionPageSensor, [
        {
            key: "getCollectionID2",
            value: // eslint-disable-next-line class-methods-use-this
            function getCollectionID2(oID) {
                return window.atob(oID).replace(/\D/g, '');
            }
        },
        {
            key: "CollectionShow",
            value: function CollectionShow() {
                var data = {
                    collection_id: CollectionPageSensor.getCollectionID(),
                    collection_name: CollectionPageSensor.getCollectionName()
                };
                this.getSensors().track('CollectionShow', data);
            }
        },
        {
            key: "SortMethodClick",
            value: function SortMethodClick(sortMethod) {
                var data = {
                    collection_id: CollectionPageSensor.getCollectionID(),
                    collection_name: CollectionPageSensor.getCollectionName(),
                    sort_method: sortMethod
                };
                this.getSensors().track('SortMethodClick', data);
            }
        },
        {
            key: "CollectionTurnPage",
            value: function CollectionTurnPage(turnType) {
                var data = {
                    collection_id: CollectionPageSensor.getCollectionID(),
                    collection_name: CollectionPageSensor.getCollectionName(),
                    turn_page_type: turnType
                };
                this.getSensors().track('CollectionTurnPage', data);
            }
        },
        {
            key: "CollectionLeave",
            value: function CollectionLeave() {
                var data = {
                    collection_id: CollectionPageSensor.getCollectionID(),
                    collection_name: CollectionPageSensor.getCollectionName(),
                    product_number: _basefunc__WEBPACK_IMPORTED_MODULE_0__/* ["default"].visited_product.length */ .Z.visited_product.length,
                    stay_time: this.getStayTime()
                };
                this.getSensors().track('CollectionLeave', data);
            }
        },
        {
            key: "Action",
            value: function Action() {
                this.CollectionShow();
            }
        }
    ], [
        {
            key: "getCollectionID",
            value: function getCollectionID() {
                var _id, ref;
                return (ref = window.atob((_id = this.getMain().getElementsByClassName('collection')[0].dataset.id) !== null && _id !== void 0 ? _id : '').replace(/\D/g, '')) !== null && ref !== void 0 ? ref : '';
            }
        },
        {
            key: "getCollectionName",
            value: function getCollectionName() {
                var _name;
                return (_name = this.getMain().getElementsByClassName('collection')[0].dataset.name) !== null && _name !== void 0 ? _name : '';
            }
        }
    ]);
    return CollectionPageSensor;
}(_basefunc__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
var isServer = !true;
var collectionPageSensor = null;
/* harmony default export */ __webpack_exports__["default"] = ((function() {
    if (!isServer) {
        collectionPageSensor = new CollectionPageSensor();
    }
    return collectionPageSensor;
})());


/***/ })

}]);